import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { mainNav } from '../../data/navigation';
import { NavPanel } from './NavPanels';
import { isNavActive } from '../../utils/navigation';
import type { MenuId } from '../../types/content';
export function DesktopNav() {
  const [open, setOpen] = useState<MenuId | null>(null);
  const {
    pathname
  } = useLocation();
  const closeTimer = useRef<number>();
  const navRef = useRef<HTMLElement>(null);
  useEffect(() => setOpen(null), [pathname]);
  useEffect(() => {
    function onKey(event: KeyboardEvent) {
      if (event.key === 'Escape') setOpen(null);
    }
    function onClick(event: MouseEvent) {
      if (navRef.current && !navRef.current.contains(event.target as Node)) setOpen(null);
    }
    window.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onClick);
    return () => {
      window.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onClick);
    };
  }, []);
  function openMenu(id: MenuId) {
    window.clearTimeout(closeTimer.current);
    setOpen(id);
  }
  function scheduleClose() {
    window.clearTimeout(closeTimer.current);
    closeTimer.current = window.setTimeout(() => setOpen(null), 140);
  }
  return <nav ref={navRef} aria-label="Main" className="hidden h-full lg:block" onMouseLeave={scheduleClose} data-id="element-527" data-mp="1yplouq3egh4g">
      <ul className="flex h-full items-center" data-id="element-528" data-mp="23ooxekil95h6">
        {mainNav.map(item => {
        const active = isNavActive(item, pathname);
        const base = `relative inline-flex h-[72px] items-center gap-1 whitespace-nowrap px-3 type-menu transition-colors duration-150 ${active ? 'text-ink after:absolute after:inset-x-3 after:bottom-0 after:h-[2px] after:bg-brand' : 'text-body hover:text-ink'}`;
        return <li key={item.label} onMouseEnter={() => item.menu ? openMenu(item.menu) : scheduleClose()} data-id="element-529" data-mp="1lmswtkpx3yrm">
              {item.menu ? <button type="button" className={base} aria-expanded={open === item.menu} aria-controls={`menu-${item.menu}`} onClick={() => setOpen(open === item.menu ? null : item.menu ?? null)} data-id="element-530" data-mp="1unzgg2nv5pp3">
                  {item.label}
                  <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ease-brand ${open === item.menu ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-531" data-mp="1zm0zinlahp0k" />
                </button> : <Link to={item.to} className={base} aria-current={active ? 'page' : undefined} data-id="element-532" data-mp="2nceryf7sdpvo">
                  {item.label}
                </Link>}
            </li>;
      })}
      </ul>
      <AnimatePresence data-id="element-533" data-mp="31yu0or965rvb">
        {open ? <motion.div key={open} id={`menu-${open}`} initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -6
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} onMouseEnter={() => openMenu(open)} className="absolute inset-x-0 top-full bg-white shadow-[0_24px_48px_-28px_rgba(0,0,0,0.25)]" data-id="element-534" data-mp="32051qjb8cliq">
            <div className="mx-auto max-w-content px-8 py-10" data-id="element-535" data-mp="2nzc61v96zke1">
              <NavPanel id={open} data-id="element-536" data-mp="2o0x2xrizbff2" />
            </div>
          </motion.div> : null}
      </AnimatePresence>
    </nav>;
}